export default __webpack_public_path__ + "static/media/CNo.64-2.eaa67361.jpg";